export default __webpack_public_path__ + "static/media/product-16.9acfa26b.webp";